//====================================================
//  Function: Reviews
//====================================================
function componentProduct() {
  if ($(".products").length) {
    $(".products .product").each(function () {
      var inst = $(this);
      if (inst.find(".prices .price-standard").length) {
        return true;
      }

      var flags = inst.find(".flags.flags-default");
      var productTitle = inst.find(".p-in-in span").text();
      var productFlagHeight;

      if (productTitle.indexOf("120") >= 0) {
        addFlag(flags, "120");
      }

      if (productTitle.indexOf("150") >= 0) {
        addFlag(flags, "150");
      }

      if (productTitle.indexOf("180") >= 0) {
        addFlag(flags, "180");
      }

      if (productTitle.indexOf("210") >= 0) {
        addFlag(flags, "210");
      }

      var priceDiscount = inst.find(".price-save");
      flags.append(priceDiscount);

      var pricesBlock = inst.find(".p-bottom .prices");

      var priceStandard = inst.find(".price-standard");
      pricesBlock.prepend(priceStandard);

      var priceFinal = inst.find(".p-bottom > div");
      if (langSk) {
        if (parseInt(priceFinal.data("micro-price")) > 100) {
          inst
            .find(".p-in")
            .append(
              '<div class="product-delivery-free">' + freeDeliveryExt + "</div>"
            );
        }
      }

      if (langCs) {
        if (parseInt(priceFinal.data("micro-price")) > 2500) {
          inst
            .find(".p-in")
            .append(
              '<div class="product-delivery-free">' + freeDeliveryExt + "</div>"
            );
        }
      }

      if (inst.find(".dklabCountdownClassic").length) {
        inst
          .find(".p-bottom > div")
          .append(inst.find(".dklabCountdownClassic"));
      }

      inst.find(".btn-cart").text(addToBasket);
    });

    function addFlag(flags, flagText) {
      flags.append(
        '<span class="flag flag-tip"><svg class="icon-svg icon-tree-size"><use xlink:href="https://www.365121.myshoptet.' +
          lang +
          '/user/documents/public/images/sprites.svg#icon-tree-size"></use></svg>' +
          flagText +
          " cm</span>"
      );
    }
  }

  if ($(".in-index .content .products").length) {
    $(".products").after(
      '<div class="txt-c"><button class="load-all-product margin-top-2 btn btn--black-outline btn--min-width-medium d-md-none">' +
        loadMore +
        "</button></div>"
    );
    $(".products .product").addClass("swiper-slide");
    $(".products").addClass("swiper-wrapper");
    $(".products").wrap(
      '<div class="js-slider-group"><div class="swiper-container js-slider-products-favorite"></div></div>'
    );
    $(".js-slider-products-favorite").append(
      '<div class=" swiper-pagination swiper-pagination-hero js-swiper-pagination"></div>'
    );

    if ($(window).width() > 768) {
      productFavoriteSlider();
    }

    $(document).on("click", ".load-all-product", function () {
      $(".in-index .content .js-slider-group").addClass("is-shown");
      $(".in-index .content .products-block").addClass("is-shown");
      $(window).trigger("resize");

      $("html, body")
        .stop()
        .animate({
          scrollTop:
            $(".in-index .content .product:nth-child(3)").offset().top - 100,
        });
      return false;
    });
  }
}

function componentProductOne(inst) {
  if ($(".products").length) {
    inst.find(".product").each(function () {
      var inst = $(this);
      if (inst.find(".prices .price-standard").length) {
        return true;
      }

      var flags = inst.find(".flags.flags-default");
      var productTitle = inst.find(".p-in-in span").text();
      var productFlagHeight;

      if (productTitle.indexOf("120") >= 0) {
        addFlag(flags, "120");
      }

      if (productTitle.indexOf("150") >= 0) {
        addFlag(flags, "150");
      }

      if (productTitle.indexOf("180") >= 0) {
        addFlag(flags, "180");
      }

      if (productTitle.indexOf("210") >= 0) {
        addFlag(flags, "210");
      }

      var priceDiscount = inst.find(".price-save");
      flags.append(priceDiscount);

      var pricesBlock = inst.find(".p-bottom .prices");

      var priceStandard = inst.find(".price-standard");
      pricesBlock.prepend(priceStandard);

      var priceFinal = inst.find(".p-bottom > div");
      if (langSk) {
        if (parseInt(priceFinal.data("micro-price")) > 100) {
          inst
            .find(".p-in")
            .append(
              '<div class="product-delivery-free">' + freeDeliveryExt + "</div>"
            );
        }
      }

      if (langCs) {
        if (parseInt(priceFinal.data("micro-price")) > 2500) {
          inst
            .find(".p-in")
            .append(
              '<div class="product-delivery-free">' + freeDeliveryExt + "</div>"
            );
        }
      }

      if (inst.find(".dklabCountdownClassic").length) {
        inst
          .find(".p-bottom > div")
          .append(inst.find(".dklabCountdownClassic"));
      }

      inst.find(".btn-cart").text(addToBasket);
    });

    function addFlag(flags, flagText) {
      flags.append(
        '<span class="flag flag-tip"><svg class="icon-svg icon-tree-size"><use xlink:href="https://www.365121.myshoptet.' +
          lang +
          '/user/documents/public/images/sprites.svg#icon-tree-size"></use></svg>' +
          flagText +
          " cm</span>"
      );
    }
  }
}

function componentProductModal() {
  if ($("#cboxWrapper").length) {
    $("#cboxWrapper .product").each(function () {
      var inst = $(this);
      if (inst.find(".prices .price-standard").length) {
        return true;
      }

      var flags = inst.find(".flags.flags-default");
      var productTitle = inst.find(".p-in-in span").text();
      var productFlagHeight;

      if (productTitle.indexOf("120") >= 0) {
        addFlag(flags, "120");
      }

      if (productTitle.indexOf("150") >= 0) {
        addFlag(flags, "150");
      }

      if (productTitle.indexOf("180") >= 0) {
        addFlag(flags, "180");
      }

      if (productTitle.indexOf("210") >= 0) {
        addFlag(flags, "210");
      }

      var priceDiscount = inst.find(".price-save");
      flags.append(priceDiscount);

      var pricesBlock = inst.find(".p-bottom .prices");

      var priceStandard = inst.find(".price-standard");
      pricesBlock.prepend(priceStandard);

      var priceFinal = inst.find(".p-bottom > div");

      if (langSk) {
        if (parseInt(priceFinal.data("micro-price")) > 100) {
          inst
            .find(".p-in")
            .append(
              '<div class="product-delivery-free">' + freeDeliveryExt + "</div>"
            );
        }
      }

      if (langCs) {
        if (parseInt(priceFinal.data("micro-price")) > 2500) {
          inst
            .find(".p-in")
            .append(
              '<div class="product-delivery-free">' + freeDeliveryExt + "</div>"
            );
        }
      }

      if (inst.find(".dklabCountdownClassic").length) {
        inst
          .find(".p-bottom > div")
          .append(inst.find(".dklabCountdownClassic"));
      }

      inst.find(".btn-cart").text(addToBasket);
    });

    function addFlag(flags, flagText) {
      flags.append(
        '<span class="flag flag-tip"><svg class="icon-svg icon-tree-size"><use xlink:href="https://www.365121.myshoptet.' +
          lang +
          '/user/documents/public/images/sprites.svg#icon-tree-size"></use></svg>' +
          flagText +
          " cm</span>"
      );
    }
  }
}
